import React, { Fragment, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'shards-react'
import MiniAppService from '../../../../services/mini-app-service/MiniAppService'
import '../../invite-accept-screen.css'

export default function ApprovedSolicitationMessage({ miniAppInformations, goToLoginPage }) {
    ApprovedSolicitationMessage.propTypes = {
        miniAppInformations: PropTypes.object,
        goToLoginPage: PropTypes.func,
    }

    const [repository, setRepository] = useState(null)

    useEffect(() => {
        const { slug } = miniAppInformations
        const getRepositoryUrlFromMetadata = async slug => {
            const miniApp = await MiniAppService.findMiniAppBySlugWithoutToken(slug)
            return setRepository(miniApp?.metadata?.git_repo ? miniApp.metadata.git_repo : null)
        }

        getRepositoryUrlFromMetadata(slug)
    }, [miniAppInformations.slug])

    return (
        <Fragment>
            <i className="material-icons invite-accept--icon--approved" style={{ fontSize: 75 }}>
                check_circle
            </i>
            <p>Olá, convidado.</p>
            <p>Você foi aprovado para participar no projeto</p>
            <p>
                <span className="invite-accept--mini-app-text--bold">{` ${miniAppInformations.miniAppName}.`}</span>
            </p>
            {repository && (
                <p>
                    Clone o repositorio{' '}
                    <a className="invite-accept--link" href={repository}>
                        {miniAppInformations.slug}
                    </a>
                </p>
            )}
            <p>
                Acesse a nossa
                <a className="invite-accept--link" href="https://developer.ame.calindra.com.br/">
                    {' '}
                    documentação{' '}
                </a>
                para fazer seu signup e acessar nosso Portal de Administração de Mini Apps, bem como ter acesso a muitos
                outros recursos.
            </p>
            <Button id="invite-accept--back-button" onClick={goToLoginPage}>
                Acessar o portal
            </Button>
        </Fragment>
    )
}
